import { useEffect, useState } from "react";
import SearchResultBlock from "../../components/Block";
import Map from "../map/Map";
import { useAppSelector } from "../../app/hooks";
import { selectAddress } from "../address/addressSlice";
import "../search/Search.css";
import { ResultBlockType } from "../../types";
import { Box, Table, TableBody, TableHead, TableRow, TableCell, Button } from "@mui/material";
import { Switch, switchClasses } from '@mui/base/Switch';
import { styled } from '@mui/system';
import Icon from '../../components/Icon'

/* from https://mui.com/base-ui/react-switch/ */
const blue = {
  200: '#99CCF3',
  500: '#007FFF',
  700: '#0059B2',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const Root = styled('span')(
  ({ theme }) => `
  box-sizing: border-box;
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 30px;
  height: 16px;
  margin: 0 0 1px 0;
  cursor: pointer;

  &.${switchClasses.disabled} {
    opacity: 0.4;
    cursor: not-allowed;
  }

  & .${switchClasses.track} {
    box-sizing: border-box;
    // background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
    // border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    background: white;
    border: 2px solid rgba(5, 5, 5, 0.3);
    border-radius: 24px;
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
    box-shadow: inset 0 1px 1px ${
      theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.05)'
    };
  }

  &:hover .${switchClasses.track} {
    // background: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
    // border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
    border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
  }

  &.${switchClasses.focusVisible} .${switchClasses.track} {
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
  }

  & .${switchClasses.thumb} {
    box-sizing: border-box;
    // border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    border: none;
    display: block;
    width: 8px;
    height:8px;
    top: 4px;
    left: 4px;
    border-radius: 16px;
    // background-color: #FFF;
    background-color: rgba(5, 5, 5, 0.3);
    position: relative;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
    box-shadow: 0 1px 2px ${
      theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.1)'
    };
  }

  &.${switchClasses.checked} {
    .${switchClasses.thumb} {
      left: 18px;
      // background-color: #fff;
      background-color: gray;
      background-color: rgba(5, 5, 5, 0.7);
      box-shadow: 0 1px 2px rgb(0 0 0 / 0.3);
    }

    .${switchClasses.track} {
      // border: none;
      // background: ${blue[500]};
      border: 2px solid rgba(5, 5, 5, 0.7);
    }
  }

  &:hover .${switchClasses.checked} .${switchClasses.track} {
    background: ${blue[700]};
  }

  & .${switchClasses.input} {
    cursor: inherit;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    margin: 0;
  }
  `,
);

const StyledInput = function(props: any) {
  return (
    <input {...props} style={{
      width: 50,
      borderColor: "rgba(5, 5, 5, 0.3)",
      borderRadius: 5,
      height: 16,
      margin: 0,
      fontSize: "0.8em",
      textAlign: "center",
    }}/>
  )
}

const containerIconStyle: Record<string, string|number> = {
  justifyContent: "center",
  alignItems: "center",
  width: "35px",
  height: "35px",
  borderRadius: "50%",
  boxShadow: "0px 4px 16px 0px rgba(189, 189, 189, 1)",
  marginRight: 8,
  backgroundColor: "#124376"
};

export default function WarrentyThresholdBlock({
  iconType,
  title,
  id,
}: ResultBlockType) {
  const address = useAppSelector(selectAddress);

  const [zoom/*, setZoom*/] = useState(8); // initial zoom
  const [center, setCenter] = useState<google.maps.LatLngLiteral>({
    lat: 48.866667,
    lng: 2.333333,
  });

  useEffect(() => {
    if (
      !address ||
      !address.value ||
      !address.value.latitude ||
      !address.value.longitude
    ) {
      return;
    }
    setCenter({ lat: address.value.latitude, lng: address.value.longitude });
    // setZoom(18);
  }, [address]);

  return (
    <SearchResultBlock
      style={{ display: "flex", flexDirection: "column" }}
      className="MapResultBlock"
      iconType={iconType}
      id={id}
      title={title}
    >
      <div style={{ flex: 1, paddingRight: "10px" }}>
        <Map
          mapId="90f87356969d889c"
          center={center}
          zoom={zoom}
          style={{ height: "600px", margin: "10px 0" }}
          // placeId={address.value?.placeId}
          data4HomeInfo={
            address && address.value
              ? {
                  buildings: address.value.buildings,
                  parcels: address.value.parcels,
                  empriseBatieParis: address.value.empriseBatieParis,
                }
              : undefined
          }
        />
      </div>
      <Table>
        <TableHead sx={{backgroundColor: "#ece9fd"}}>
          <TableRow sx={{textTransform: "uppercase"}}>
            <TableCell sx={{backgroundColor: "#ece9fd", flex: 1, marginBottom: 0.5}}>Phénomène</TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF"}}>Description</TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", textAlign: "center"}}>Valeur</TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", textAlign: "center"}}>Actif</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{marginBottom: 0.5}}>
            <TableCell sx={{backgroundColor: "#ece9fd", textTransform: "uppercase", fontWeight: "bold", color: "#124376"}}>
              <Box sx={{display: "flex", alignItems: "center"}}>
                <Icon
                  type="WINDS"
                  iconStyle={{width: 45}}
                  containerStyle={{
                    ...containerIconStyle,
                }}/>
                <span>Vent</span>
              </Box>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", fontSize: "0.9em", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0, listStyle: "disc"}}>
                <li>Vitesse max des rafales à la station météo la plus proche</li>
                <li>Vitesse max rafales à l’adresse postale</li>
                <li>Direction du vent des rafales les plus fortes</li>
                <li>Vitesse moyenne du vent à la station la plus proche sur la durée voulue (24 heures +/- 72 heures) </li>
                <li>Orientation dominante du vent</li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li><StyledInput type="number"/> km/h</li>
                <li><StyledInput type="number"/> km/h</li>
                <li><StyledInput type="number"/> km/h</li>
                <li><StyledInput type="number"/> km/h</li>
                <li><StyledInput type="number"/> °</li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} defaultChecked /></li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow sx={{marginBottom: 0.5}}>
            <TableCell sx={{backgroundColor: "#ece9fd", textTransform: "uppercase", fontWeight: "bold", color: "#124376"}}>
              <Box sx={{display: "flex", alignItems: "center"}}>
                <Icon
                  type="HEAVY_RAIN"
                  iconStyle={{width: 25}}
                  containerStyle={{
                    ...containerIconStyle,
                }}/>
                <span>Fortes pluies</span>
              </Box>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", fontSize: "0.9em", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0, listStyle: "disc"}}>
                <li>Accumulation totale des précipitations sur :</li>
                <ul style={{marginTop: 0, paddingTop: 0, marginLeft: 14, listStyle: "disc"}}>
                  <li>12 heures.</li>
                  <li>24 heures.</li>
                  <li>48 heures.</li>
                  <li>72 heures.</li>
                </ul>
                <li>Les périodes sont des paramètres de la plateforme.</li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li><StyledInput type="number"/> mm</li>
                <li><StyledInput type="number"/> mm</li>
                <li><StyledInput type="number"/> mm</li>
                <li><StyledInput type="number"/> mm</li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li><Switch slots={{ root: Root, }} /></li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow sx={{marginBottom: 0.5}}>
            <TableCell sx={{backgroundColor: "#ece9fd", textTransform: "uppercase", fontWeight: "bold", color: "#124376"}}>
              <Box sx={{display: "flex", alignItems: "center"}}>
                <Icon
                  type="THUNDER"
                  iconStyle={{width: 23}}
                  containerStyle={{
                    ...containerIconStyle,
                }}/>
                <span>Orage</span>
              </Box>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", fontSize: "0.9em", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0, listStyle: "disc"}}>
                <li>Impacts de foudre :</li>
                <ul style={{marginTop: 0, paddingTop: 0, marginLeft: 14, listStyle: "disc"}}>
                  <li>Au moins un impact recensé dans un rayon de </li>
                  <li>Plus de X (paramétrage) impacts dans un rayon de 10 kms</li>
                </ul>
                <li>Accumulation des précipitations.</li>
                <li>Vitesse max des rafales à la station météo la plus proche.</li>
                <li>Vitesse max rafales à l’adresse postale.</li>
                <li>Présence de grêle (oui / non).</li>
                <li>Tailles des grêlons supérieur à X</li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li>&nbsp;</li>
                <li><StyledInput type="number"/> km/h</li>
                <li><StyledInput type="number"/></li>
                <li><StyledInput type="number"/> mm</li>
                <li><StyledInput type="number"/> km/h</li>
                <li><StyledInput type="number"/> km/h</li>
                <li><StyledInput type="number"/> </li>
                <li><StyledInput type="number"/> </li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li>&nbsp;</li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
              </ul>
            </TableCell>
          </TableRow>
          <TableRow sx={{marginBottom: 0.5}}>
            <TableCell sx={{backgroundColor: "#ece9fd", textTransform: "uppercase", fontWeight: "bold", color: "#124376"}}>
              <Box sx={{display: "flex", alignItems: "center"}}>
                <Icon
                  type="COLD_WAVE"
                  iconStyle={{width: 15}}
                  containerStyle={{
                    ...containerIconStyle,
                }}/>
                <span>Gel</span>
              </Box>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", fontSize: "0.9em", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0, listStyle: "disc"}}>
                <li>Température minimale inférieure à X</li>
                <li>Durée de l’épisode de gel supérieur à X</li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li><StyledInput type="number"/> °C</li>
                <li><StyledInput type="number"/> heures</li>
              </ul>
            </TableCell>
            <TableCell sx={{flex: 1, borderRight: "1px solid #EFEFEF", verticalAlign: "top"}}>
              <ul style={{marginTop: 0, marginBottom: 0, marginLeft: 8, paddingTop: 0}}>
                <li><Switch slots={{ root: Root, }} /></li>
                <li><Switch slots={{ root: Root, }} /></li>
              </ul>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Box sx={{
        marginY: 2,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "end",
      }}>
        <Button sx={{color: "#124376", fontSize: "0.8em", textDecoration: "underline"}}>Annuler</Button>
        <Button variant="contained" sx={{backgroundColor: "#124376", borderRadius: 0, marginLeft: 3}}>Enregistrer</Button>
      </Box>
    </SearchResultBlock>
  );
}
